import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/link/link.tsx
import "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { jsx } from "react/jsx-runtime";
var Link = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, children, variant = "underline", size = "default", icon, className } = _b, rest = __objRest(_b, ["asChild", "children", "variant", "size", "icon", "className"]);
    const Component = asChild ? Slot : "a";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadProps(__spreadValues({
        className: clsx(
          "hds-link",
          variant !== "underline" && `hds-link--${variant}`,
          size !== "default" && `hds-link--${size}`,
          { "hds-link--trailing-icon": icon === "trailing" },
          { "hds-link--leading-icon": icon === "leading" },
          className
        ),
        ref
      }, rest), {
        children
      })
    );
  }
);
Link.displayName = "Link";

export {
  Link
};
//# sourceMappingURL=chunk-OHDHIRAW.mjs.map